module.exports = __webpack_public_path__ + "gfx/logo.svg";